import { render } from "./CustomHtml.vue?vue&type=template&id=2526b526&scoped=true"
import script from "./CustomHtml.vue?vue&type=script&lang=ts"
export * from "./CustomHtml.vue?vue&type=script&lang=ts"

import "./CustomHtml.vue?vue&type=style&index=0&id=2526b526&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2526b526"

export default script